import { z } from 'zod'

// 2xx 以外の応答の本文（gatewayErrors.ts の AGENT_GATEWAY_ERRORS のどれか）。画面が失敗の理由を読むときに使う
export const agentGatewayErrorResponseSchema = z.object({ code: z.string(), message: z.string() })
